export const normalizeString = (str: string) => str.toLocaleLowerCase().trim().replace(/\s+/g, " ").trim();
